import users from './users'
import inviteUser from './inviteUser'
export default { users, inviteUser }
